import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmOptionsService } from '@app/services/confirm-options.service';
import { DashboardService } from '@app/services/dashboard.service';
import { DealerService } from '@app/services/dealer.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-regional-detail',
	templateUrl: './regional-detail.component.html',
	styleUrls: ['./regional-detail.component.css'],
})
export class RegionalDetailComponent implements OnInit {
	data: any;
	busy: Subscription;
	id: string;
	deleteDealerSwal: ConfirmOptionsService;

	edit = {
		username: false,
		telefono: false,
		cellulare: false,
		email: false,
		cattivo_pagatore: false,
	};

	loading = {
		username: false,
		telefono: false,
		cellulare: false,
		email: false,
		cattivo_pagatore: false,
	};

	constructor(
		private route: ActivatedRoute,
		private spinner: NgxSpinnerService,
		private dashboardService: DashboardService,
		private router: Router,
		private dealerService: DealerService,
		private toastr: ToastrService
	) {
		this.route.params.subscribe((params) => {
			this.id = params['id'];
			this.reload(); // reset and set based on new parameter this time
		});

		this.deleteDealerSwal = new ConfirmOptionsService({
			title: 'Se sicuro di voler cancellare questa utenza?',
			text: 'Non potrai tornare indietro',
			confirmButtonText: 'Si',
			cancelButtonText: 'Annulla',
		});
	}

	get regional() {
		if (this.data) {
			return this.data.regional;
		}
		return {
			ragsociale: '',
		};
	}

	ngOnInit(): void {}

	saveRegionalInfo(params: any, key: string) {
		if (key === 'cattivo_pagatore') {
			params.cattivo_pagatore = params.cattivo_pagatore ? 1 : 0;
		}
		this.loading[key] = true;
		this.dealerService.updateDealerAnagrafica(this.id, params).subscribe(
			(data) => {
				this.toastr.success('Dati modificati con successo!', 'Operazione completata', {
					positionClass: 'toast-top-right',
				});
				this.loading[key] = false;
				this.edit[key] = false;
				this.reload();
			},
			(error) => {
				this.toastr.error('Impossibile modificare i dati, contattare il supporto', 'Errore', {
					positionClass: 'toast-top-right',
				});
				this.loading[key] = false;
				this.edit[key] = false;
				this.reload();
			}
		);
	}

	reload() {
		this.spinner.show();
		this.busy = this.dashboardService.get(`/regional-dettaglio?id=${this.id}`).subscribe(
			(data) => {
				this.data = data.result;
				this.spinner.hide();
			},
			(error) => {
				this.router.navigate(['/retailers/list']);
			}
		);
	}

	deleteDealer() {
		this.spinner.show();
		this.dealerService.deleteDealer(this.id).subscribe(
			(data) => {
				this.spinner.hide();
				this.router.navigate(['/retailers/list']);
			},
			(error) => {
				this.spinner.hide();
				this.router.navigate(['/retailers/list']);
			}
		);
	}
}
